import { useRef, useState } from "react";

interface FileDropzoneProps {
  label: string;
  controlId: string;
  hint: string;
  emptyLabel: string;
  fileName: string | null;
  onFile: (file: File | null) => void;
  dropLabel: string;
}

export function FileDropzone({
  label,
  controlId,
  hint,
  emptyLabel,
  fileName,
  onFile,
  dropLabel,
}: FileDropzoneProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);
  const pick = (fileList: FileList | null) => {
    onFile(fileList?.[0] ?? null);
  };
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">{label}</div>
      <p className="text-sm text-muted-foreground">{hint}</p>
      <input
        className="block w-full text-sm file:mr-3 file:rounded-lg file:border-0 file:bg-muted file:px-3 file:py-2 file:text-sm file:font-medium"
        data-control-id={`${controlId}.input`}
        onChange={(event) => pick(event.target.files)}
        ref={inputRef}
        type="file"
      />
      <button
        className={`mt-2 flex min-h-28 w-full flex-col items-center justify-center rounded-xl border border-dashed px-4 py-6 text-center text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30 ${
          dragging
            ? "border-primary bg-primary/10 text-primary"
            : "border-border bg-muted/40 text-muted-foreground hover:bg-muted"
        }`}
        data-control-id={`${controlId}.dropzone`}
        onClick={() => inputRef.current?.click()}
        onDragEnter={(event) => {
          event.preventDefault();
          setDragging(true);
        }}
        onDragLeave={(event) => {
          event.preventDefault();
          setDragging(false);
        }}
        onDragOver={(event) => event.preventDefault()}
        onDrop={(event) => {
          event.preventDefault();
          setDragging(false);
          pick(event.dataTransfer.files);
        }}
        type="button"
      >
        <span>{fileName ?? dropLabel}</span>
        {!fileName ? <span className="mt-1 text-xs font-normal opacity-80">{emptyLabel}</span> : null}
      </button>
    </div>
  );
}
